import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Component, OnInit, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { finalize, interval, Subscription, take } from 'rxjs';

import { FilledInputDirective } from '@shared/directives/filledInput.directive';
import { TextOnlyDirective } from '@shared/directives/textOnly.directive';
import { AuthService } from '@app/features/auth/services/auth.service';
import { Spinner } from '@shared/components/spinner/spinner';
import { Utility } from '@common/utility';

@Component({
  selector: 'app-sign-up',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TextOnlyDirective,
    FilledInputDirective,
    Spinner,
    NgOptimizedImage
  ],
  providers: [AuthService, Utility],
  templateUrl: './sign-up.html',
  styleUrl: './sign-up.scss'
})
export class SignUp implements OnInit {
  signUpForm: FormGroup;
  showPassword = false;
  showConfirmPassword = false;
  loader = signal(false);
  isSignUp = false;
  sentEmail: string = ''
  isResetBtnDisabled = signal(true)
  buttonText = signal('02:00');
  inviteData = signal<any>(null)
  private countdownSubscription: Subscription | null = null;
  constructor(private fb: FormBuilder, private authService: AuthService, public utility: Utility, private router: Router, private route: ActivatedRoute) {
    this.signUpForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['', Validators.required],
      terms: [false, Validators.requiredTrue]
    })
  }
  ngOnInit(): void {
     const data = JSON.parse(localStorage.getItem('invited_user_data'));
     if(data){
      this.inviteData.set(data?.data)
            this.signUpForm.get('email').setValue(data?.data?.email)
            this.signUpForm.get('email').disable()
     }
    // if (token) {
    //   this.authService.verifyInvitationToken(token).subscribe({
    //     next: ((res) => {
    //       if (res.success === true) {
    //         this.inviteData.set(res.data)
    //         this.signUpForm.get('email').setValue(res.data.email)
    //         this.signUpForm.get('email').disable()
    //       }
    //     })
    //   })
    // }
  }
  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }

  toggleConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  onSubmit(): void {
    const payload = {
      first_name: this.signUpForm.get('firstName')?.value,
      last_name: this.signUpForm.get('lastName')?.value,
      email: this.signUpForm.get('email')?.value,
      password: this.signUpForm.get('password')?.value,
      confirm_password: this.signUpForm.get('confirmPassword')?.value,
      is_invited_user: this.inviteData()?.is_valid,
      invited_by_owner_id: this.inviteData()?.invited_by_owner_id,
      workspace_id: this.inviteData()?.workspace_id
    }
    this.loader.set(true)
    this.authService.userSignUp(payload).pipe(
      finalize(() => {
        this.loader.set(false);
      })
    ).subscribe({
      next: (res) => {
        if (res?.success === true) {
          if (res.data.user.is_invited_user) {
            this.router.navigate(['/login'])
          } else {
            localStorage.setItem('sign-up-email', res.data.user.email)
            this.isSignUp = true;
            this.sentEmail = this.signUpForm.value.email
            this.startCountdown(10)
          }
        }
      },
      error: (err) => {
        this.mapErrors(err?.error?.errors);
      },
    })
  }
  startCountdown(duration: number) : void {
    this.isResetBtnDisabled.set(true);
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
    this.updateButtonText(duration);
    this.countdownSubscription = interval(1000)
      .pipe(take(duration))
      .subscribe({
        next: (elapsed) => {
          const timeLeft = duration - elapsed - 1;
          this.updateButtonText(timeLeft);
        },
        complete: () => {
          this.isResetBtnDisabled.set(false);
        },
      });
  }

  private updateButtonText(seconds: number)  : void {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const mm = minutes < 10 ? '0' + minutes : minutes;
    const ss = secs < 10 ? '0' + secs : secs;
    this.buttonText.set(`${mm}:${ss}`);
  }
  resendEmail() : void {
    const email = localStorage.getItem('sign-up-email')
    const data = {
      email: email
    }
    this.startCountdown(120);
    this.authService.resendEmail(data).subscribe()
  }
  mapErrors(json: any): void {
    if (json?.first_name) {
      this.signUpForm.get('firstName')?.setErrors({ serverError: json.first_name[0] })
    }
    if (json?.last_name) {
      this.signUpForm.get('lastName')?.setErrors({ serverError: json.last_name[0] })
    }
    if (json?.email) {
      this.signUpForm.get('email')?.setErrors({ serverError: json.email[0] })
    }
    if (json?.password) {
      this.signUpForm.get('password')?.setErrors({ serverError: json.password[0] })
    }
    if (json?.confirm_password) {
      this.signUpForm.get('confirmPassword')?.setErrors({ serverError: json.confirm_password })
    }
  }
}
